/*

# Dependencies
	- mod.js
	- jquery 1.7+

*/

(function($, mod) {
	"use strict";

	mod.observer = {

		/*
			[{ context:(js class), fn:function() {}}]
		*/
		_subscribers : {},

		_queues : {},

		// Add a function listener for a particular key
		bind : function(type, fn, context, onlyOnce) {
			onlyOnce = onlyOnce || false;

			if (type && fn && context) {
				this._subscribers[type] = this._subscribers[type] || [];

				this._subscribers[type].push({
					context : context || window,
					fn : fn
				});
			}
			else {
				console.error("mod.observer.bind: must provide a type, fn, and context.");
			}
		},

		unbind : function(type, fn, context) {
			var i, sub,
				subs = this._subscribers[type];

			for (i = subs.length - 1; i >= 0; i--) {
				sub = subs[i];

				if (sub.fn === fn && sub.context === context) {
					this._subscribers[type].splice(i, 1);
					break;
				}
			}

			// Remove the list if it's empty
			if (!this._subscribers[type].length) {
				delete this._subscribers[type];
			}
		},

		// Remove all events that meet the condition
		unbindAll : function(conditionFn) {
			var type, subs, i, sub;

			if (conditionFn) {
				for (type in this._subscribers) {
					subs = this._subscribers[type];

					for (i = subs.length - 1; i >= 0; i--) {
						sub = subs[i];

						// Check each subscriber against the condition
						if (conditionFn(sub.fn, sub.context)) {
							this._subscribers[type].splice(i, 1);
						}
					}

					// Remove the list if it's empty
					if (!this._subscribers[type].length) {
						delete this._subscribers[type];
					}
				}
			}
			else {
				console.error("mod.observer.unbindAll: must provide a condition function.");
			}
		},

		// Execute a function listener for a particular key and pass it data
		trigger : function(type, data, callback) {
			if (this._subscribers[type]) {
				for (var i = this._subscribers[type].length - 1; i >= 0; i--) {
					var subscriber = this._subscribers[type][i];
					subscriber.fn.call(subscriber.context, data);
				}

				if (callback) {
					callback();
				}
			}

			mod.log("mod.observer: triggered \"" + type + "\" for", this._subscribers[type]);
		},

		// Add data to a queue
		queue : function(type, data) {
			if (type && data) {
				this._queues[type] = this._queues[type] || [];
				this._queues[type].push(data);
			}
		},

		// Get all the data from a queue and pass it to a callback
		dequeue : function(type, callback) {
			if (type && this._queues[type]) {
				callback(this._queues[type]);
				delete this._queues[type];
			}
		}

	};

})(jQuery, window.mod);